import { useEffect, useState } from "react";
import { Grid, LinearProgress, Typography, Box, Stack, Divider } from "@mui/material";
import MatchedLogChart from "./statPyramid";
import { boxStyle } from "../../../../../theme";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const cardConfig = [
  { key: "dayOfWeek", label: "Worst Day" },
  { key: "hour", label: "Worst Hour" },
  { key: "ipSorgente", label: "Top Source" },
  { key: "ipDestinatario", label: "Top Destination" },
  { key: "dettaglio", label: "Top Detail" },
];

const StatCard = ({ label, value, score }) => (
  <Box
    sx={{
      backgroundColor: "#1a1a1a",
      borderLeft: "3px solid #c0392b",
      px: 2,
      py: 1.5,
      minWidth: 140,
      flex: 1,
    }}
  >
    <Typography sx={{ fontSize: 11, color: "#aaa", mb: 0.5, textTransform: "uppercase", letterSpacing: 0.5 }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#fff", lineHeight: 1.2 }}>
      {value || "N/A"}
    </Typography>
    <Typography sx={{ fontSize: 11, color: "#888", mt: 0.5 }}>
      {score != null ? `${(score * 100).toFixed(0)} anomaly score` : "N/A"}
    </Typography>
  </Box>
);

const Stat = ({ dataStat }) => {
  const [matchScore, setMatchScore] = useState(0);
  const [matchCombination, setMatchCombination] = useState([]);
  const [anomaliesData, setAnomaliesData] = useState({});

  useEffect(() => {
    const anomalies = dataStat.anomalies ?? {};
    setAnomaliesData(anomalies);
    setMatchScore(dataStat?.match_analysis?.matchScore ?? 0);
    setMatchCombination(dataStat?.match_analysis?.matched_combinations ?? []);
  }, [dataStat]);

  return (
    <Box sx={{ ...boxStyle }}>
      <Stack direction="row" spacing={0} sx={{ mb: 2, flexWrap: "wrap", gap: 1 }}>
        {cardConfig.map(({ key, label }) => (
          <StatCard
            key={key}
            label={label}
            value={anomaliesData[key]?.value}
            score={anomaliesData[key]?.score}
          />
        ))}
      </Stack>
      <Grid container spacing={2} height={"60vh"}>
        <Grid size={12} sx={{ display: "flex", height: "100%" }}>
          <Stack direction={"column"} spacing={2} alignItems={"center"} height={"100%"} width={"100%"}>
            <Typography sx={{ mt: 2, fontSize: 18, fontWeight: 900 }}>
              Matches Values / Logs
            </Typography>
            <Divider sx={{ width: "90%", color: "#eaeaea" }} />
            <LinearProgressWithLabel
              variant="determinate"
              value={matchScore}
              sx={{
                height: 8,
                borderRadius: 10,
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#459095",
                  borderRadius: 10,
                },
              }}
            />
            <Box width={"100%"}>
              <MatchedLogChart
                matchedCombinations={[...matchCombination].sort((a, b) => a.log_count - b.log_count) ?? []}
              />
            </Box>
            {/* const labelMapping = {
              dayOfWeek: "Day of Week",
              dettaglio: "Detail",
              hour: "Hour",
              ipDestinatario: "Destination IP",
              ipSorgente: "Source IP",
            };
            <Stack direction={"column"} spacing={2} overflow={"auto"} width={"80%"}>
              {matchCombination.map((item, index) => (
                <Stack key={index} direction={"row"} spacing={2} justifyContent={"start"} alignItems={"start"}>
                  <Typography sx={{ fontSize: 12 }}>Combination:</Typography>
                  {item.matched_fields.map((field, i) => (
                    <Typography key={i} sx={{ fontSize: 14, fontWeight: 600 }}>
                      | {labelMapping[field]} |
                    </Typography>
                  ))}
                  <Stack direction={"row"} spacing={2} ml={5}>
                    <Typography sx={{ fontSize: 12 }}>Log Count for this Combination:</Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{item.log_count}</Typography>
                  </Stack>
                </Stack>
              ))}
            </Stack> */}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Stat;
